import {FormProvider, useForm} from "react-hook-form";
import {useCreateStoreServiceContext} from "../../context/create-service";
import {
  CreateStoreServiceBasicFormStepFormValues,
  createStoreServiceBasicFormStepFormValidationSchema,
} from "./schema-validation";
import {yupResolver} from "@hookform/resolvers/yup";
import {Alert, Button, Col, Row, Space} from "antd";
import {StyledServiceButtonWrapper} from "../../../../../styles/onboarding/onboarding";
import {useNavigate} from "react-router-dom";
import {CreateServiceOfferingForm} from "../../../../../components/offering-form/services";
import {
  useCreateEditStoreServiceHook,
  useCreateStoreServiceHook,
} from "../../hooks/create-service";
import {CreateStoreServiceFormValues} from "../../reducers/create-service/types";

export function CreateServiceBasicFormStep() {
  const navigate = useNavigate();
  const {
    dispatch,
    state: {formData, apiResponseData},
  } = useCreateStoreServiceContext();

  const formMethods = useForm<CreateStoreServiceBasicFormStepFormValues>({
    resolver: yupResolver(createStoreServiceBasicFormStepFormValidationSchema),
    mode: "onSubmit",
    defaultValues: formData,
  });

  const {createStoreService, isCreatingService} = useCreateStoreServiceHook();
  const {createEditStoreService, isCreateServiceEditing} =
    useCreateEditStoreServiceHook();

  function onSubmit(values: CreateStoreServiceBasicFormStepFormValues) {
    if (apiResponseData) {
      const payload: CreateStoreServiceFormValues = {
        ...formData,
        ...values,
      };
      createEditStoreService(payload, () => {
        dispatch({
          type: "update-create-service-form-step",
          payload: "coverImagesUpload",
        });
      });
    } else {
      const payload: CreateStoreServiceFormValues = {
        bookingQuestions: [],
        currencies: values.currencies,
        deliveryTimeFrameUnit: values.deliveryTimeFrameUnit,
        deliveryTimeFrameValue: values.deliveryTimeFrameValue,
        description: values.description,
        hideFromProfile: values.hideFromProfile,
        isUrlRedirect: values.isUrlRedirect,
        redirectAfterPurchase: values.redirectAfterPurchase,
        telegramGroupId: values.telegramGroupId,
        name: values.name,
        priceType: values.priceType,
        requestCustomerPhoneNumber: values.requestCustomerPhoneNumber,
        limitUnitsPerTransaction: values.limitUnitsPerTransaction,
        purchaseLimit: values.purchaseLimit,
        url_redirect: values.url_redirect,
        enable_currency_conversion: true,
        selected_currencies: values.selected_currencies || [],
      };
      createStoreService(payload);
    }
  }

  const isFormError = Object.keys(formMethods.formState.errors).length > 0;
  const isGeneralInformationError =
    formMethods.formState.errors.name || formMethods.formState.errors.description;
  const isPricingError =
    formMethods.formState.errors.priceType || formMethods.formState.errors.currencies;
  const isSettingsError =
    formMethods.formState.errors.hideFromProfile ||
    formMethods.formState.errors.isUrlRedirect ||
    formMethods.formState.errors.redirectAfterPurchase ||
    formMethods.formState.errors.telegramGroupId ||
    formMethods.formState.errors.requestCustomerPhoneNumber ||
    formMethods.formState.errors.limitUnitsPerTransaction ||
    formMethods.formState.errors.purchaseLimit ||
    formMethods.formState.errors.url_redirect;
  const isDeliveryTimeframeError =
    formMethods.formState.errors.deliveryTimeFrameUnit ||
    formMethods.formState.errors.deliveryTimeFrameValue;

  // console.log({watch: formMethods.watch(), errors: formMethods.formState.errors});
  return (
    <FormProvider {...formMethods}>
      <form onSubmit={formMethods.handleSubmit(onSubmit)} autoComplete="off">
        <Space direction="vertical" size={16} style={{display: "flex"}}>
          <CreateServiceOfferingForm
            isGeneralInformationError={!!isGeneralInformationError}
            isPricingError={!!isPricingError}
            isSettingsError={!!isSettingsError}
            isDeliveryTimeFrameError={!!isDeliveryTimeframeError}
          />
          {isFormError && (
            <Alert
              message="Please fill in the required fields above, outlined in red"
              type="warning"
            />
          )}

          <Row gutter={[0, 16]}>
            <Col span={24} sm={12}>
              <StyledServiceButtonWrapper>
                <Button
                  onClick={() => {
                    dispatch({
                      type: "reset-state",
                    });
                    navigate("/products?activeTab=services");
                  }}
                  block
                  size="small"
                  type="default"
                >
                  Back
                </Button>
                <Button
                  block
                  type="primary"
                  htmlType={"submit"}
                  size="small"
                  disabled={isFormError || Object.values(formMethods.watch()).length < 1}
                  loading={isCreatingService || isCreateServiceEditing}
                >
                  Next
                </Button>
              </StyledServiceButtonWrapper>
            </Col>
          </Row>
        </Space>
      </form>
    </FormProvider>
  );
}
